import React from 'react'

import { Icon, Discount, Dollar } from '@cgtrader/triangle-ui/dist/src/ssr-index'

const getSubscriptionCheckbox = (translate) => ({
  value: 'with_subscription',
  label: (
    <span className="filter-wrapper__option--with-icon">
      <Icon notSpaced svgComponent={Dollar} color="primary" size="small" />
      <span>{translate('search_page.filters.price.with_subscription')}</span>
    </span>
  ),
})

export const getPricingCheckboxFiltersConfig = (translate, withSubscriptionCheckbox) => [{
  label: '',
  filters: [
    {
      value: 'on_sale',
      label: (
        <span className="filter-wrapper__option--with-icon">
          <Icon notSpaced svgComponent={Discount} color="primary" size="small" />
          <span>{translate('search_page.filters.price.on_sale')}</span>
        </span>
      ),
    },
    ...(withSubscriptionCheckbox ? [getSubscriptionCheckbox(translate)] : []),
  ],
}]
